// @ts-nocheck
import { useTranslation } from "react-i18next";
import { Dropdown, message, Select, Space } from "antd";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import "./index.css";
import { useState } from "react";

export default function C2CCKTS({}) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const lan = localStorage.getItem("i18n");

  return (
    <div className="flex flex-col items-center justify-center p-6 bg-neutral-800 rounded-lg">
      <div className="relative w-16 h-16 mb-4">
        <div className="absolute inset-0 border-4 border-transparent border-t-primary rounded-full animate-spin"></div>
        <div className="absolute inset-0 border-4 border-transparent border-r-primary-light rounded-full animate-spin" style={{ animationDuration: '1.5s' }}></div>
        <div className="absolute inset-0 border-4 border-transparent border-b-primary-dark rounded-full animate-spin" style={{ animationDuration: '2s' }}></div>
        <div className="absolute inset-0 border-4 border-transparent border-l-neutral-400 rounded-full animate-spin" style={{ animationDuration: '2.5s' }}></div>
      </div>
      <p className="text-neutral-100 text-center text-base animate-pulse">
        {translate(getText("匹配C2C商家中，請您耐心等待1-5分鐘"))}
        ...
      </p>
    </div>
  );
}
